import React, { createContext, useContext } from 'react';
import { getDocumentTitle } from '../services/metadataUtils';
import { getEnvVariableByKey } from '../../utils/tenantUtils';

export interface Metadata {
  documentTitle?: string;
  lang?: string;
}

const localizedFallbackTitles: Record<string, string> = {
  de: 'Agile Forms von Syngenio',
  en: 'Agile Forms by Syngenio',
  fr: 'Formulaires Agile par Syngenio',
  it: 'Moduli Agile di Syngenio',
};

// avoid default documentTitle to allow injection from environment META_TITLE as default documentTitle
const defaultMetadata: Metadata = {
  documentTitle:
    getEnvVariableByKey('META_TITLE') ||
    localizedFallbackTitles[document.documentElement.lang || 'de'],
  lang: 'de',
};

const MetadataContext = createContext<Metadata>(defaultMetadata);

export const useMetadata = () => useContext(MetadataContext);

interface MetadataProviderProps {
  metadata: Metadata;
  project?: string;
  children: React.ReactNode;
}

export const MetadataProvider: React.FC<MetadataProviderProps> = ({
  metadata,
  project,
  children,
}) => {
  const actualMetadata: Metadata = {
    documentTitle: getDocumentTitle(project, metadata.documentTitle),
    lang: metadata.lang || defaultMetadata.lang,
  };

  return (
    <MetadataContext.Provider value={actualMetadata}>
      {children}
    </MetadataContext.Provider>
  );
};
